import { LEGAL_POLICIES } from "../data/constants/legalPolicies";
import type {
  ConsentStatusItem,
  ConsentSelections,
  ConsentDerivedState,
  ConsentPayloadItem,
  RecordConsentBody,
  ConsentType,
} from "./consentTypes";

export function deriveConsentState(consents: ConsentStatusItem[] | undefined): ConsentDerivedState {
  const isGranted = (type: ConsentType) =>
    consents?.find((c) => c.consent_type === type)?.action === "granted";

  const termsGranted = isGranted("terms");
  const privacyGranted = isGranted("privacy");
  const marketingGranted = isGranted("marketing");

  return {
    termsGranted,
    privacyGranted,
    marketingGranted,
    needsConsent: !termsGranted || !privacyGranted,
  };
}

export function canSubmit(sel: ConsentSelections): boolean {
  return sel.terms && sel.privacy;
}

export function buildConsentPayload(sel: ConsentSelections, source: string, appVersion: string): RecordConsentBody {
  const toAction = (checked: boolean) => (checked ? "granted" : "withdrawn");

  const consents: ConsentPayloadItem[] = [
    {
      consent_type: "terms",
      action: toAction(sel.terms),
      policy_version: LEGAL_POLICIES.terms.version,
      policy_hash: LEGAL_POLICIES.terms.hash,
    },
    {
      consent_type: "privacy",
      action: toAction(sel.privacy),
      policy_version: LEGAL_POLICIES.privacy.version,
      policy_hash: LEGAL_POLICIES.privacy.hash,
    },
    // Marketing: no policy metadata (backend fields optional for marketing).
    { consent_type: "marketing", action: toAction(sel.marketing) },
  ];

  return { consents, source, app_version: appVersion };
}

export function shouldShowConsentGate(args: {
  userId: unknown;
  isAuthorized: boolean;
  pathname: string;
  isLoading: boolean;
  statusError: unknown;
  needsConsent: boolean;
}): boolean {
  const { userId, isAuthorized, pathname, isLoading, statusError, needsConsent } = args;
  if (!userId || !isAuthorized) return false;
  if (pathname.startsWith("/onboarding")) return false;
  if (isLoading || statusError) return false; // fail-open on read
  return needsConsent;
}
